import React, {PureComponent} from 'react';

import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import style from './IndexTrending.css';


const TrendingItem = ({item}) => {
  if (!item.live){
    return null;
  }

  return <li className={style.li}>
    <Link to={`/lives/${item.live.id}`}>
      {item.topic}
    </Link>
  </li>
}

class IndexTrending extends PureComponent {
  render() {
    let {indexBundle} = this.props;
    console.log('searches', indexBundle.dailyHotSearches)

    return (
        <section>
          {/*<h3>*/}
          {/*  趋势*/}
          {/*  <FireIcon size={20} fill={'red'} />*/}
          {/*</h3>*/}
          {/*<div className="btn-toolbar btn-group btn-group-sm">*/}
          {/*  <a href="" className="btn btn-primary">热搜</a>*/}
          {/*  <a href="" className="btn btn-light">热门文章</a>*/}
          {/*  <a href="" className="btn btn-light">单独</a>*/}
          {/*</div>*/}
          {/*<br/>*/}
          <ol className={style.ol}>
            {indexBundle.dailyHotSearches.slice(0, 9).map((search, idx) => {
              return <TrendingItem item={search} key={'s' + search.id}/>
            })}
          </ol>
        </section>
    )
  }
}

export default connect(({indexBundle}) => ({indexBundle}))(IndexTrending);
